import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Map, CircleMarker, Polyline, Marker, TileLayer, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import map from "lodash/map";
import { withStyles } from '@material-ui/core/styles';

import { divIcon, point } from "leaflet";
import AppCss from "./containers/app.css";
import LegendControl from "./map_legend";
import SignalMeter from "./signalMeter";
import { Portal } from "react-leaflet-portal";

// const AnyReactComponent = ({ text }) => <div>{text}</div>;


export const suitcasePoint = new L.Icon({
  iconUrl: require('./assets/images/car-marker.png'),
  iconRetinaUrl: require('./assets/images/car-marker.png'),
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
  iconSize: [40, 40],
  shadowUrl: './assets/images/marker-shadow.png',
  shadowSize: [29, 40],
  shadowAnchor: [7, 40],
}) 


const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    // padding: theme.spacing.unit * 1,
    // padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
    height: '100%',

  },
  circle: {
    color: 'green',
    backgroud: 'white',

  },
});

let position = [
  37.774304,
  -122.441951,
];
const cover = { position: 'relative', width: '100%', height: '70%' };

class MapCard extends Component {
  constructor(props) {
    super(props);

    // this.onWaypointsChange = this.onWaypointsChange.bind(this);

    this.state = {
      waypoints: [],
      positions: [
        [43.604403, 1.443373],
        [43.613547, 1.308568]
      ]
    };
  }
  static defaultProps = {
    center: {
      lat: 37.774304,
      lng: -122.441951
    },
    zoom: 11,
  };



  render() {
    const { vehicles } = this.props;
    // const {waypoints,  positions } = this.state;

    let positions = vehicles.map(function (x) {
      return [x['lat'], x['long']];
    });
    // console.log('positions', positions[0]);
    // const bounds = L.latLngBounds(positions);
    {/* <CircleMarker  style={{  backgroundColor:"#fff"}}   center={[vehicle.lat, vehicle.long]} radius={8} attribution={index}> <Popup>speed:{vehicle.speed}<br />time:{vehicle.timestamp}</Popup>
                </CircleMarker> */}
    let curMark = null;
    let curSpeed = 0;
    let curSignal = ""
    if (positions[this.props.pos]) {
      position = positions[this.props.pos];

      curSpeed = vehicles[this.props.pos]["speed"];
      curSignal = vehicles[this.props.pos]["rssi"];
      curMark = <Marker position={positions[this.props.pos]} icon={suitcasePoint} >
        <Popup>speed:{curSpeed}<br /> Signal:{curSignal}</Popup>
      </Marker>
      // ts = new Date(  vehicles[this.props.pos]["timestamp"]);
    }

    //     var info = L.control();
    // info.onAdd = function (Map) {
    //     this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
    //     this.update();
    //     return this._div;
    // };

    // // method that we will use to update the control based on feature properties passed
    // info.update = function (props) {
    //     this._div.innerHTML = '<h4>US Population Density</h4>' +  (props ?
    //         '<b>' + props.name + '</b><br />' + props.density + ' people / mi<sup>2</sup>'
    //         : 'Hover over a state');
    // };

    // info.addTo(Map);

    return (

      <div  >
        <Map center={position} zoom={16} style={cover} attributionControl={false}   >
          <TileLayer
            url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />

          <Polyline
            positions={positions}
            color={'green'}
            weight={10}
            opacity={0.4}
          />
          {curMark}
          <Portal style={{ borderRadius: 5, }} position="topright">
            <div style={{ backgroundColor: "#000", display: 'flex', width: "150px", fontSize: 14, color: "#fff", opacity: 0.7, padding: 6 }}>
              <span  >{curSpeed} mph </span>       {/* <br /> */}
              <SignalMeter strength={curSignal * 25} /> <span  >{curSignal} </span>
              {/* <button onClick={this.handlePortalClick}>Click me!</button> */}
            </div>
          </Portal>
          {
            map(vehicles, (vehicle, index) => {
              const { timestamp, type } = vehicle;
              let classes = {
                [AppCss.marker]: true,
                [AppCss.bus]: true
              }
              // classes[AppCss.bus] = true;
              // if (type == 'rail') {
              //   classes[AppCss[`rail${timestamp}`]] = true;
              // } else if (type == 'bus') {
              //   classes[AppCss.bus] = true;
              // }
              const icon = divIcon({ className: classnames(classes), html: `<span>${index}</span>` });
              //   const iconBtn=`<IconButton               

              // > 
              //   <AccountCircle />${index}
              // </IconButton>`
              //   const icon = divIcon({ className: classnames(classes), html: {iconBtn} });
              return (
                // <Marker   key={index} position={[vehicle.lat, vehicle.long]} ><Popup>speed:{vehicle.speed}<br />time:{vehicle.timestamp}</Popup> </Marker>
                <CircleMarker style={{ color: "red" }} className={classes.circle} key={index} center={[vehicle.lat, vehicle.long]} radius={5} attribution={index}   >
                  <Popup>speed:{vehicle.speed}<br />time:{vehicle.timestamp}</Popup>
                </CircleMarker>
              )
            })
          }

        </Map>
      </div>

    )
  }
}

const mapStateToProps = (state) => {
  return {
    vehicles: state.vehicles
  }
}
export default withStyles(styles)(connect(mapStateToProps)(MapCard));



// --- With Google Maps 
// <div style={{ height: '100vh', width: '100%' }}>
//           <GoogleMapReact
//             bootstrapURLKeys={{ key: ' ' }}
//             defaultCenter={position}
//             defaultZoom={this.props.zoom}
//           >
//             <AnyReactComponent
//               lat={59.955413}
//               lng={30.337844}
//               text={'Indo-mars.com/geotracker'}
//             />
//             {
//               map(vehicles, (vehicle) => {
//                 const { routeNumber, type } = vehicle;
//                 let classes = {
//                   [AppCss.marker]: true
//                 }
//                 if (type == 'rail') {
//                   classes[AppCss[`rail${routeNumber}`]] = true;
//                 } else if (type == 'bus') {
//                   classes[AppCss.bus] = true;
//                 }

//                 const icon = divIcon({ className: classnames(classes), html: `<span>${routeNumber}</span>` });
//                 return (
//                   <Marker icon={icon} key={vehicle.vehicleID} position={[vehicle.latitude, vehicle.longitude]} />
//                 )
//               })
//             }
//           </GoogleMapReact>
//         </div>